import { Box, createTheme, Link, Typography } from '@mui/material';
import React, { FC, useContext } from 'react';
import { constants } from '../../constants/constants';
import { useTranslation } from 'react-i18next';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';
import SurveyUtils from '../../shared/SurveyUtils';
import Autolink from '../Autolink/Autolink';
import { SurveyRateUsButton } from '../SurveyRateUsButton/SurveyRateUsButton';

interface Props {
  id: string;
  companyLogo: string;
  primary: string;
  platform: string;
  platformUrl: string;
  platformName: string;
  secondary: string;
  companyWebsiteUrl: string;
  customFont: string;
  title?: string;
  introText?: string;
  outroText?: string;
  companyName?: string;
  feedbackActive?: boolean;
  shouldShowPrivacyNotice?: boolean;
  privacyNoticeText?: string;
  privacyNoticeLink?: string;
}

const PositiveFeedback: FC<Props> = ({
  id,
  primary,
  platform,
  secondary,
  customFont,
  platformUrl,
  platformName,
  title,
  introText,
  outroText,
  shouldShowPrivacyNotice,
  privacyNoticeText,
  privacyNoticeLink,
}) => {
  const theme = createTheme();
  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation();
  const t = localContext ? localContext.t : globalT;

  return (
    <Box
      className="survey-outro survey-outro--positive survey-outro--nps"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Typography
        className="survey-title survey-outro-title"
        variant="h4"
        sx={{
          color: primary,
          fontWeight: 'bold',
          textAlign: 'center',
          mb: theme.spacing(4),
          fontFamily: customFont,
        }}
      >
        {title}
      </Typography>
      {introText && (
        <Typography
          className="survey-intro-text survey-outro-intro-text"
          variant="h5"
          sx={{
            color: secondary,
            fontWeight: 'light',
            fontSize: '1.1rem',
            mt: 4,
            mb: 4,
            lineHeight: '1.5',
            textAlign: 'center',
            fontFamily: customFont,
          }}
        >
          <Autolink text={introText} />
        </Typography>
      )}
      {outroText && (
        <Typography
          className="survey-outro-text"
          variant="h5"
          sx={{
            color: secondary,
            fontWeight: 'light',
            mt: theme.spacing(1),
            fontFamily: customFont,
          }}
        >
          <Autolink text={outroText} />
        </Typography>
      )}
      {platformUrl && (
        <>
          <Box
            className="survey-rate-us-wrapper"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: 'fit-content',
              margin: '0 auto',
              mb: 4,
            }}
          >
            <SurveyRateUsButton
              surveyId={id}
              surveyType={'nps'}
              platformUrl={platformUrl}
              platform={platform ?? ''}
              platformName={platformName}
              theme={theme}
              primary={primary}
              customFont={customFont}
            ></SurveyRateUsButton>
          </Box>
        </>
      )}
    </Box>
  );
};

export default PositiveFeedback;
